import { ComponentState } from '../../../types/ComponentStates.types';
import { LabeledComponent, LabeledComponentProperties, LabeledComponentProps } from '../inputs/LabeledComponent';
import AutocompleteMultiDropdown, { AutocompleteMultiDropdownProps } from './AutocompleteMultiDropdown';

interface LabeledProps extends Omit<LabeledComponentProps, 'children'> {
  errorMessage?: string | undefined;
}

interface LabeledStateAutocompleteMultiDropdownProps {
  id: string;
  state: ComponentState;

  labeledProps: LabeledProps;
  dropdownProps: AutocompleteMultiDropdownProps;
}

export const LabeledStateAutocompleteMultiDropdown = ({
  id,
  labeledProps,
  dropdownProps,
  state,
}: LabeledStateAutocompleteMultiDropdownProps) => {
  const { errorMessage, stateProperties: labeledStateProperties } = labeledProps;

  const myStateProperties: LabeledComponentProperties = {
    error: {
      message: errorMessage,
      color: 'text-error',
    },
    default: {},
    ...labeledStateProperties,
  };

  const labeledComponentProps = {
    id,
    state,
    stateProperties: myStateProperties,
    ...labeledProps,
  };

  return (
    <LabeledComponent {...labeledComponentProps}>
      <AutocompleteMultiDropdown {...dropdownProps} />
    </LabeledComponent>
  );
};
